import React, {Component, Fragment} from 'react';
import DataTable from 'react-data-table-component';

import { InputGroup } from "react-bootstrap";


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import PaginationV2 from '@app/components/Pagination/V2';
import Spinner from '@app/components/Spinner';
import axios from '@app/lib/axios';

import * as Constant from "@app/Constant.js";


const basePagingInfo = { perPage: 18, maxShowPage: 10 };
const ROW_PER_PAGE = 18;


const easyFilter = [

	{	
		displayKey: '포함',
        displayName: '키워드 포함',
        test: function(filterValue, cellValue) {
          if (cellValue == null) return false;
          return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {	
    	displayKey: '일치',
        displayName: '키워드 일치',
        test: function(filterValue, cellValue) {
          
          return filterValue == cellValue;
        },
    }

]

export default class CsList extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	      error: null,
	      isLoaded: this.props.listLoaded ? this.props.listLoaded : false,
	      items: this.props.csList ? this.props.csList : [],
	      searchKeyword : "",
	      tableData : this.props.csList ? this.props.csList : [],
	      tableSummary : "",
	      rowSelection : 'single',
		  total_cnt: this.props.total_cnt ,
		  page : this.props.page,
		  pageSize : 15,
		  row: this.props.row,
		  onRowSelected: this.props.onRowSelected,
	      defaultColDef: {
	        resizable:true,
	        enableRowGroup: true,
	        enablePivot: true
	      },
		  keyword: null,
		  onSelectPage: this.props.onSelectPage,
		  onSearchKeyword: this.props.onSearchKeyword
		};
	}


	rowClick = (agGrid) => {
		this.props.rowClickCbFnc(agGrid.api.selectionController.lastSelectedNode.data.id);
	}
	
	componentWillReceiveProps = (nextProps) => {
		
		this.setState({
			isLoaded: nextProps.listLoaded ? nextProps.listLoaded : false,
		    items: nextProps.csList ? nextProps.csList : [],
		    searchDate : nextProps.targetDate ? nextProps.targetDate : new Date()
		}, () => {
			this.setState({
				tableData: this.listSearch(this.state.searchKeyword),
				total_cnt: nextProps.total_cnt,
				page: nextProps.page,
				row: nextProps.row,
				onSelectPage: nextProps.onSelectPage
			})
			
		})
	}

	handleDateChange = (date) => {
		this.setState({
			searchDate : date
		});
		this.props.listCallFn(date);
	}

	searchData = (e) => {
		
		var keyword = e.target.value;
		
		var tableData = this.listSearch(keyword);		

		this.setState({
			tableData : tableData,
			searchKeyword : keyword
		});
	}
	
	listSearch = (keyword) => {
		var list = this.state.items;
		var tableData = [];
		if(!keyword) {
			tableData = list;
		} else {
			list.map(item => {

				var phoneKeyword = keyword.replace(/-/g, '');

				if(item.phone && item.phone.replace(/-/g, '').indexOf(phoneKeyword) >= 0 ) {
					tableData.push(item);
				} else if (item.organization && item.organization.indexOf(keyword) >= 0) {
					tableData.push(item);
				} else if ( item.question && item.question.indexOf(keyword) >= 0) {
					tableData.push(item);
				} else if ( item.answer && item.answer.indexOf(keyword) >= 0) {
					tableData.push(item);
				} else  {
					// ignore ;
				}
			});
		}
		return tableData;
	}
	
	rowDataChanged = (parmas) => {
		this.setState({
			tableSummary : this.state.tableData.length.toLocaleString() + " / " + this.state.total_cnt.toLocaleString()
		})
	}

	filterChanged = (parmas) => {
		
		this.setState({
			tableSummary : parmas.api.rowModel.rowsToDisplay.length.toLocaleString()+ " / " + this.state.total_cnt.toLocaleString()
		})
	}

	handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.state.onSearchKeyword(this.state.keyword);
        }
    };

	searchKeyword = () => {
		this.state.onSearchKeyword(this.state.keyword)
	}
	changeKeyword = (keyword) => {
		this.setState({keyword: keyword.target.value});
	}

	render() {
		// headerName: "Make", field: "make", sortable: true, filter: true
		const listColumn = [
			{
			    headerName: "요청일",
			    field: "request_date",
			    sortable: true,
			    filter: true,
			    filter: 'agDateColumnFilter',
			    width : 180,
			    minWidth : 180,
			    pin: true,
			    // add extra parameters for the date filter
			    filterParams: {
			    	filterOptions: [
			    		{	
            				displayKey: '일치',
			                displayName: '날짜 일치',
			                test: function(filterLocalDateAtMidnight, cellValue) {

			                    var dateAsString = cellValue;

					            if (dateAsString == null) {
					                return false;
					            }
					            
					            var dateParts = dateAsString.split('-');
					            var day = Number(dateParts[2]);
					            var month = Number(dateParts[1]) - 1;
					            var year = Number(dateParts[0]);
					            var cellDate = new Date(year, month, day);


					            return filterLocalDateAtMidnight.getFullYear() == year && 
					            	filterLocalDateAtMidnight.getMonth() == month &&
					            	filterLocalDateAtMidnight.getDate() == day
					            	;
			                },
			            },
			    	],
			        // provide comparator function
			        comparator: function(filterLocalDateAtMidnight, cellValue) {
			            var dateAsString = cellValue;

			            if (dateAsString == null) {
			                return 0;
			            }
			            
			            var dateParts = dateAsString.split('-');
			            var day = Number(dateParts[2]);
			            var month = Number(dateParts[1]) - 1;
			            var year = Number(dateParts[0]);
			            var cellDate = new Date(year, month, day);

			            // Now that both parameters are Date objects, we can compare
			            if (cellDate < filterLocalDateAtMidnight) {
			                return -1;
			            } else if (cellDate > filterLocalDateAtMidnight) {
			                return 1;
			            } else {
			                return 0;
			            }
			        }
			    },
	        	cellRenderer : (param) => {
	        		var html = "<div>" + param.value;

	        		if(param.data.is_complete === 'N')  html += ' <span class="text-danger mr-1 mr-1"><i class="fas fa-question-circle"></i></span>';
	        		if(param.data.is_issue === 'Y')  html += ' <span class="text-secondary mr-1 mr-1"><i class="fas fa-exclamation-circle"></i></span>';
	        		
	        		return html + "</div>"; 
	        	}
			  },
			 {
			    headerName: "상품",
			    field: "product_name",
			    sortable: true,
			    width : 130,
			    minWidth : 130,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "메뉴 분류",
			    field: "type_name",
			    width : 180,
			    minWidth : 180,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "기관",
			    field: "organization",
			    width : 200,
			    minWidth : 150,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "문의자",
			    field: "requestor",
			    width : 120,
			    minWidth : 120,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "연락처",
			    field: "phone",
			    sortable: true,
			    width : 180,
			    minWidth : 180,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			{
			    headerName: "처리 현황",
			    field: "is_complete",
			    width : 110,
			    minWidth : 110,
			    maxWidth : 110,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: [{	
				    	displayKey: '일치',
				        displayName: '일치',
				        test: function(filterValue, cellValue) {
				          return filterValue.toLowerCase() == cellValue.toLowerCase();
				        }
				    }]
            	},
			    cellStyle: function(params) {
			        if (params.value=='N') {
			            //mark police cells as red
			            return {color: 'red'};
			        } else {
			            return null;
			        }
			    }
			  },
			  {
			    headerName: "이슈 체크",
			    field: "is_issue",
			    width : 110,
			    minWidth : 110,
			    maxWidth : 110,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: [{	
				    	displayKey: '일치',
				        displayName: '일치',
				        test: function(filterValue, cellValue) {
				          return filterValue.toLowerCase() == cellValue.toLowerCase();
				        }
				    }]
            	},
			    cellStyle: function(params) {
			        if (params.value=='Y') {
			            //mark police cells as red
			            return {color: 'red'};
			        } else {
			            return null;
			        }
			    }
			  },
			  {
			    headerName: "문의 사항",
			    field: "question",
			    sortable: false,
			    width : 300,
			    minWidth : 300,
			    maxWidth : 600,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "처리 내역",
			    field: "answer",
			    sortable: false,
			    width : 300,
			    minWidth : 300,
			    maxWidth : 600,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },

			  {
			    headerName: "디바이스(모델)",
			    field: "device",
			    sortable: true,
			    width : 150,
			    minWidth : 150,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "저장공간",
			    field: "storage",
			    width : 150,
			    minWidth : 150,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "버전",
			    field: "version",
			    width : 130,
			    minWidth : 130,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "처리자",
			    field: "user_name",
			    width : 120,
			    minWidth : 120,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  }
			  
		];

		const rowClassRules = {
	        'bg-secondary-light': function(params) {
	          return params.data.is_complete === 'N' || params.data.is_issue === 'Y' ;
	        }
	      }

		const { error, isLoaded} = this.state;
	    if (error) {
	      return <div>Error: {error.message}</div>;
	    } else if (!isLoaded) {
	      return <Spinner pt={"50px"}/>;
	    } else {

			return (
					<Fragment>
					<div className="row">
						<div  className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-2 float-right">
							{this.state.tableSummary}
						</div>
						<div  className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2 float-right">
							<InputGroup className="input-group my-group">
								<input className="form-control" type="text" onChange={this.changeKeyword} placeholder="search keyword" onKeyPress={this.handleKeyPress}/>
								<InputGroup.Append>
									<input type="submit" className="btn btn-primary" value="검색" onClick={this.searchKeyword} />
								</InputGroup.Append>
							</InputGroup>
						</div>
	                	<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2 ag-theme-alpine"  style={{height: "555px"}}>
		                	<AgGridReact
		                	  style={{
		                	  	overflowX : "scroll",
		                	  	overflowY : "auto" 
		                	  }}
					          columnDefs={listColumn}
					          rowData={this.state.tableData}
					          defaultColDef={this.state.defaultColDef}
					          rowSelection="single"
              				  onSelectionChanged={this.rowClick}
					          onRowDataChanged={this.rowDataChanged}
					          onFilterChanged={this.filterChanged}
					          rowClassRules = {rowClassRules}
					        >
					        </AgGridReact>

	                	</div>
					</div>

					<div className="row" style={{marginTop : "10px"}}>
						<div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5" style={{float: 'right'}}>
                    		<PaginationV2 perPage={ROW_PER_PAGE}  maxShowPage={basePagingInfo.maxShowPage} currentPage={this.state.page} total={this.state.total_cnt} callback={this.state.onSelectPage }/>
						</div>
						
					</div>

					
				    </Fragment>
		    );
		}
	}

}